/* eslint-disable max-len */
import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const ArrowRotateDouble: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.93167 13.3158C3.04833 12.4325 2.5 11.2142 2.5 9.87417V9.87417C2.5 7.19333 4.69333 5 7.37417 5L13.3333 5.0175"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6666 6.68441L13.3333 5.01774L11.6666 3.35107"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0683 6.68408C16.9516 7.56742 17.5 8.78575 17.5 10.1257V10.1257C17.5 12.8066 15.3066 14.9999 12.6258 14.9999L6.66663 14.9824"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33329 13.3159L6.66663 14.9826L8.33329 16.6493"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
/* eslint-enable max-len */
